<template>
    <div class="row">
        <div class="col-12">
            <h1 class="mb-4">{{$t('profile-picture')}}</h1>
            <!--Loading Image-->
            <div class="row" v-if="!imageURL && !cameraActive">
                <div class="col-12">
                    <div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
                        <div class="card-body text-center">
                            <b-spinner 
                                variant="primary" 
                                label="Spinning"
                                font-scale="7.5"
                            />
                            <h5 class="card-title">{{ $t("loading") }}</h5>
                            <p class="card-text">
                                {{ $t("loading-image") }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!--Image Capture-->
            <div class="col-4 mx-auto text-center" v-if="cameraActive && hasPriv">
                <div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
                    <div class="card-body text-center">
                        <div class="row">
                            <div class="col-12 text-center">
                                <video 
                                    ref="video"
                                    width="90%"
                                    autoplay></video>
                                <button 
                                    class="btn btn-primary" 
                                    @click="captureImage">
                                    {{$t('capture')}}
                                </button>
                                <button 
                                    class="btn btn-danger ml-1" 
                                    @click="cancelCapture">
                                    {{$t('cancel')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    


            <div class="col-4 mx-auto text-center" v-if="imageURL && hasPriv">
                <div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
                    <div class="card-body text-center">
                        <!--Image Saved Alert-->
                        <b-alert
                            :show="dismissCountDown"
                            dismissible
                            variant="success"
                            @dismissed="dismissCountDown=0"
                            @dismiss-count-down="countDownChanged"
                        >
                            {{$t('image-saved')}}
                        </b-alert>

                        <!-- Hidden File Input for Uploading -->
                        <input type="file" 
                            ref="fileInput" 
                            @change="onFileChange" 
                            style="display: none;" 
                            accept="image/*"
                        />

                        <!--Image Editor-->
                        <div class="row" v-if="editImage && !cameraActive && imageURL"> 
                            <div class="col-12">
                                <ImageEditor 
                                    @image-output="handleImageURL"
                                    :imageURL="imageURL"
                                />
                            </div>
                        </div>
                        <div class="row" v-if="imageURL && !editImage && !cameraActive">
                            <div class="col-12 text-center"> 
                                <img 
                                    v-if=imageURL
                                    :src="imageURL" 
                                    :alt="$t('uploaded-image')"
                                    ref="image"
                                    width="340px"
                                />
                            </div>

                            <!--Controls-->
                            <div class="col-12 text-center">
                                <button 
                                    v-if="!newPicture"
                                    class="btn btn-primary mt-1"
                                    @click="editImage = true"
                                >
                                    {{  $t('edit') }}
                                </button>

                                <button 
                                    v-if="!newPicture"
                                    class="btn btn-primary mt-1 ml-1"
                                    @click="newPicture = true"
                                >
                                    {{  $t('new') }}
                                </button>

                                <button
                                    v-if="newPicture"
                                    class="btn btn-primary mt-1" 
                                    @click="uploadImage"
                                >
                                    {{$t('upload')}}
                                </button>

                                <button v-if="newPicture"
                                    class="btn btn-primary ml-1 mt-1" 
                                    @click="takePicture"
                                >
                                    {{$t('take-picture')}}
                                </button>

                                <button 
                                    v-if="imageFile 
                                    && !(editImage || newPicture || previousAvatar)" 
                                    class="btn btn-primary ml-1 mt-1"
                                    @click="saveImage">
                                        {{  $t('save') }}
                                </button>
                                <button 
                                    v-if="imageFile 
                                    && !(editImage || newPicture || previousAvatar)" 
                                    class="btn btn-danger ml-1 mt-1"
                                    @click="cancel">
                                        {{  $t('cancel') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                
            </div>
        </div>
    </div>
</template>
<script>
import ImageEditor from "src/components/ImageEditor.vue";

export default {
    components: {
        ImageEditor
    },
    data() {
        return {
            imageURL: null,
            imageFile: null,
            editImage: false,
            cameraActive: false,
            newPicture: false,
            previousAvatar: true,
            loading: true,
            dismissCountDown: 0,
        }
    },
    mounted() {
        this.fetchAvatar()
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        onFileChange(e) {
            const file = e.target.files[0];
           
            if (file) {    
                this.imageURL = URL.createObjectURL(file);   
                this.imageFile = file;         
                this.previousAvatar = false;
            }
        },
        uploadImage() {
            this.$refs.fileInput.click();
            this.newPicture = false;
            this.previousAvatar = false;
        },
        takePicture() {
            this.imageURL = null;
            this.cameraActive = true;
            navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((stream) => {
                this.$refs.video.srcObject = stream;
            })
            .catch((err) => {
                console.error("Error accessing camera: ", err);
            })
            .finally(() => {
                this.newPicture = false;
                this.previousAvatar = false;
            });
        },
        captureImage() {
            const video = this.$refs.video;
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const context = canvas.getContext('2d');
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            this.imageURL = canvas.toDataURL('image/jpeg');
            this.imageFile =this.dataURLtoFile(this.imageURL, 'avatar.jpg');
            this.cameraActive = false;

            video.srcObject.getTracks().forEach(track => track.stop());
            
        },
        cancelCapture() {
            this.fetchAvatar();

            const video = this.$refs.video;
            if (video.srcObject) video.srcObject.getTracks().forEach(track => track.stop());

            this.cameraActive = false;
            video.srcObject = null;
        },
        handleImageURL(url){
            this.imageURL = url;
            if(url.startsWith('data:')) this.imageFile = this.dataURLtoFile(url, 'avatar.jpg');

            this.previousAvatar = false;
            this.editImage = false;
        },
        saveImage(){
            /*
                Our $cfetch is not adapted to handle images, 
                this is why we are doing this
            */
           
            let data = new FormData();
            data.append("username", this.$UserSession.getValue.call(this, "username"));
            data.append("authToken", this.$UserSession.getValue.call(this, "authToken"));    
            data.append("user_id", this.$UserSession.getValue("id"))   
            data.append("file", this.imageFile);

            fetch(`${this.$settings.APIBaseURL}/users/updateprofileimage`, {
                method: 'POST',
                body: data,
            })
            .then((result) => {
                if (result.status === 200) {
                    result.json().then((json) => {
                        if (json.status === "SUCCESS") {
                            this.dismissCountDown = 3;
                            this.fetchAvatar();
                        } else {
                            this.$log.error.call(this, 'Could not upload files');
                        }
                    });
                }
            })
            .catch((error) => {
                this.$log.error.call(this, error);
            }).finally(() =>{
                this.previousAvatar = true
            });
        },
        cancel(){
            this.imageURL = null;
            this.imageFile = null;
            this.editImage = false;
            this.cameraActive = false;
            this.newPicture = false;
            
            this.fetchAvatar().then(()=>{
                this.previousAvatar= true;
            }).catch(err => {
                console.error('Error fetching previous avatar:', err);
            })
            
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        fetchAvatar(){
            const id = this.$UserSession.getValue("id");
            const username = this.$UserSession.getValue("username");
            const token = this.$UserSession.getValue("authToken");

            let url = `${this.$settings.APIBaseURL}/asset/avatar/${id}?username=${username}&authToken=${token}`;

            return fetch(url)
                .then(response => {

                    this.imageURL = url;
                    
                    if(url.startsWith('data:')){
                        this.imageFile = this.dataURLtoFile(url, 'avatar.jpg');
                    } else {
                        return response.blob().then(blob => {
                            this.imageFile = new File([blob], 'avatar.jpg', { type: blob.type });
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching avatar:', error);
                    return 'ERROR';
                });
        }
    },
    computed: {
        hasPriv(){
            return this.$UserSession.hasPriv.call(this, "PROFILE_PICTURE_UPLOAD_EDIT");
        }
    }
}
</script>